import React, { useCallback } from 'react'
import { IntegrationServiceId } from '../../../../common/integrations'
import { BaseSSOIntegrationConnector } from './BaseSSOIntegrationConnector'

interface DynamicsBasedSSOIntegrationConnectorProps {
  serviceId: IntegrationServiceId
  startConnect: boolean
  onConnected: () => void
}

export const DynamicsBasedSSOIntegrationConnector: React.FC<DynamicsBasedSSOIntegrationConnectorProps> = ({ serviceId, startConnect, onConnected }) => {
  const createStateStep = `${serviceId.toLowerCase()}_discovery_step`
  return useCallback(
    () => BaseSSOIntegrationConnector({ serviceId, startConnect, onConnected, stateStep: createStateStep }),
    [serviceId, startConnect, onConnected, createStateStep],
  )()
}
